import React from 'react';
import { FaTimes } from 'react-icons/fa';

const PainelSecaoCadastroBriefing = ({ resposta, sectionStyle, onFechar }) => (
  <div className="briefing-ai-page__panel-section" style={sectionStyle}>
    <div className="briefing-ai-page__panel-section-head">
      <h2 className="briefing-ai-page__response-title">Cadastro Briefing</h2>
      <button
        type="button"
        className="briefing-ai-page__panel-section-close"
        onClick={onFechar}
        aria-label="Limpar e fechar resposta"
        title="Limpar resposta"
      >
        <FaTimes size={18} aria-hidden />
      </button>
    </div>
    <div className="briefing-ai-page__response-box">
      <pre className="briefing-ai-page__response-box-pre">
        {JSON.stringify(resposta, null, 2)}
      </pre>
    </div>
  </div>
);

export default PainelSecaoCadastroBriefing;
